import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationList } from '../models/profile.model';
import { BaseService } from './base.service';

@Injectable()
export class NavigationService extends BaseService {

  constructor(private http: HttpClient, private config: AppSettings) {
    super();
  } 

  getNavigationList():Observable<NavigationList[]>{
    const url = `${this.config.BaseUrl}Profile/Navigation/TopNavigation`;
    
    return this.http.get<NavigationList[]>(url).pipe(map(res => {
      return res;
    }));
  }
}
